import { createFileRoute } from '@tanstack/react-router'
import { ResidentIntakePage } from '../components/conversations/ResidentIntakePage'

// The printed intake address's public page (spec 2026-09-11-11).
//
// It lives outside routes/$org, so it inherits no auth guard — which is the
// point: the reader is a resident holding an AG convocation or standing at a
// notice board, with no account. The two path segments are the whole request,
// and the server answers with a strict allow-list.
//
// Unlike /c/$orgCode/$token, no thread exists yet: this is the door one is
// born through. Only a label-backed web address resolves — the desk, voice and
// generated surfaces answer the same 404 as an address that never existed.
export const Route = createFileRoute('/r/$orgCode/$address')({
    component: ResidentIntakeRoute,
})

function ResidentIntakeRoute() {
    const { orgCode, address } = Route.useParams()

    return <ResidentIntakePage orgCode={orgCode} address={address} />
}
